// extracted by mini-css-extract-plugin
module.exports = {"Container":"Log_Container__vli5H","LogContainer":"Log_LogContainer__T68Co","Title":"Log_Title__1dfKF"};